// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".gift[data-v-d96c9726] {\n  height: 16px;\n  font-size: 12px;\n  border: 1px solid #f5222d;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 1;\n  border-radius: 2px;\n  width: 20px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
